// config.js
const config = {
  // baseURL: "http://localhost:5000",
   baseURL: "https://api.helixfoundry.ai",
  REACT_APP_STRIPE_PUBLISHABLE_KEY:"pk_test_51QvFq8FzzY6wpMN8yRzqW4esKAx401Yf0YlaqqwVMF61TPNueFf0MOxaOT8osNTZPeQ377fJj5032x8LR5Oo2o6000biJxQ9Xx"
};

export default config;